import { rem } from "@certn/cascadia";
import { BasicButton, SummaryMessage, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Trans } from "react-i18next";

import { useSectionNavigation } from "../hooks";

type NotStartedProps = {
  sectionKey: string;
  showErrors: boolean;
  scrollToRef?: React.LegacyRef<HTMLDivElement> | undefined;
};

export function NotStarted(props: NotStartedProps) {
  const { sectionKey, showErrors, scrollToRef } = props;
  const { navigateToSection } = useSectionNavigation();

  return (
    <div ref={scrollToRef}>
      {showErrors && (
        <SummaryMessage type="danger">
          <Text marginTop="space-05" style="global/heading-small">
            <Trans>Incomplete step</Trans>
          </Text>
        </SummaryMessage>
      )}
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          gap: rem("space-3"),
          padding: rem("space-4"),
        })}
      >
        <Trans>This step has not been completed yet.</Trans>
        <BasicButton
          size="medium"
          onPress={() => navigateToSection(sectionKey)}
          testID={`summary-${sectionKey}-section-complete-this-step-button`}
        >
          <Trans>Complete this step</Trans>
        </BasicButton>
      </div>
    </div>
  );
}
